import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const PrevArrow = (props) => {
  return (
    <div className="ex-video-wrap">
      <div className="ex-video-slider">
        <button type="button" className="owl-prev">
          <span aria-label="Previous">‹</span>
        </button>
      </div>
    </div>
  );
};

const NextArrow = (props) => {
  return (
    <div className="ex-video-wrap">
      <div className="ex-video-slider">
        <button type="button" className="owl-next">
          <span aria-label="Next">›</span>
        </button>
      </div>
    </div>
  );
};

function ExampleVideos() {
  const sliderRef = useRef();
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const videos = [
    {
      videoName: "pop-up-video1.mp4",
      imageName: "Example-Videos-1.png",
      alt: "Example-Videos",
    },
    {
      videoName: "pop-up-video2.mp4",
      imageName: "Example-Videos-2.jpg",
      alt: "Example-Videos",
    },
    {
      videoName: "pop-up-video3.mp4",
      imageName: "Example-Videos-3.jpg",
      alt: "Example-Videos",
    },
  ];

  useEffect(() => {
    Fancybox.bind('[data-fancybox="single"]', {
      groupAttr: false,
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);
  return (
    <>
      <section className="example-videos" id="">
        <div className="row ">
          <div className="container">
            <div className="title wow zoomIn">
              <h2>
                Example <span className="red">Videos</span>
              </h2>
            </div>
            <div className="popup-content">
              <div className="popup-wrap video-slider owl-carousel">
                <Slider {...settings} ref={sliderRef} className="owl-stage">
                  {videos.map((item, index) => (
                    <div
                      key={index}
                      className="popup-box wow fadeInLeft"
                      style={{
                        visibility: "visible",
                        animationName: "fadeInLeft",
                      }}
                    >
                      <div className="popup-image">
                        <a
                          data-fancybox="single"
                          href={`images/${item.videoName}`}
                          className="popup popup-btn"
                        ></a>
                        <img
                          src={require(`../../assets/images/${item.imageName}`)}
                          alt={`${item.alt}`}
                        />
                      </div>
                    </div>
                  ))}
                </Slider>
                <div className="owl-nav disabled">
                  <button
                    type="button"
                    role="presentation"
                    className="owl-prev"
                    onClick={() => sliderRef.current?.slickPrev()}
                  >
                    <span aria-label="Previous">‹</span>
                  </button>
                  <button
                    type="button"
                    role="presentation"
                    className="owl-next"
                    onClick={() => sliderRef.current?.slickNext()}
                  >
                    <span aria-label="Next">›</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ExampleVideos;
